import React from "react"
import { Link } from "gatsby"
import { LazyLoadImage } from "react-lazy-load-image-component"

const Announcement = () => (
  <div className="announcement-top">
    <p className="mb-0">
      <LazyLoadImage src="/images/icons/tube.svg" className="mr-2" alt="" />
      <Link to="/remote/">Remote Teams: Your New Reality.</Link>
    </p>
  </div>
)

export default Announcement
